export const documentsBaseDomain = {
  nonProduction: "https://nonprod-documents.retirement-edge.com",
  production: "http://documents.retirement-edge.com",
};

export const docsPath = {
  allianzProductBrochure:
    "AZL_LifetimeIncomePlus_018815480_ProductBrochure.pdf",
};
